/* Ellinox — global behaviours. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---- Expose header height as a CSS variable ---- */
  function setHeaderHeight() {
    var header = document.querySelector('.header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }
  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  setHeaderHeight();

  /* ---- Mobile navigation drawer ---- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-mobile-nav-open]');
    var closeBtn = e.target.closest('[data-mobile-nav-close]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!drawer) return;
    if (openBtn) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    if (closeBtn || e.target === drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });

  /* ---- Product gallery thumbnail swap ---- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var mainEl = gallery.querySelector('[data-gallery-main]');
    var mainImg = mainEl && (mainEl.tagName === 'IMG' ? mainEl : mainEl.querySelector('img'));
    var full = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
    if (mainImg) mainImg.src = full;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  /* ---- Sticky mobile buy bar on product page ---- */
  var stickyBar = document.querySelector('[data-sticky-buy]');
  var buyAnchor = document.querySelector('[data-buy-anchor]');
  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buyAnchor);
  }

  /* ---- Generic quantity steppers (works for any [data-qty]) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '1', 10);
    var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Variant picker — scoped to the whole product, so title/price/
         variants/buy-button can live in separate blocks ---- */
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var data = root.querySelector('[data-variants-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-to-cart]');

    function priceTargets() {
      // price block inside the product + sticky mobile bar
      return document.querySelectorAll('[data-current-price]');
    }
    function currentOptions() {
      return Array.from(root.querySelectorAll('[data-option-index]')).map(function (el) {
        var checked = el.querySelector('input:checked') || el.querySelector('select');
        return checked ? checked.value : null;
      });
    }
    function findVariant() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable') || 'Indisponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (v.price != null) {
        priceTargets().forEach(function (el) { el.textContent = formatMoney(v.price); });
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-default-label') || 'Ajouter au panier') : (addBtn.getAttribute('data-soldout') || 'Épuisé');
      }
    }
    root.addEventListener('change', update);
  });

  /* ---- Cart page: live quantity update + remove via /cart/change.js ---- */
  (function () {
    var cart = document.querySelector('[data-cart]');
    if (!cart) return;

    function changeLine(line, quantity) {
      cart.style.opacity = '0.5';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { cart.style.opacity = ''; });
    }

    cart.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      var item = input.closest('[data-cart-item]');
      changeLine(parseInt(item.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
    });

    cart.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-cart-remove]');
      if (!remove) return;
      e.preventDefault();
      var item = remove.closest('[data-cart-item]');
      changeLine(parseInt(item.getAttribute('data-line'), 10), 0);
    });
  })();

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }
  window.EllinoxFormatMoney = formatMoney;

  /* ---- Add to cart (AJAX) + cart count refresh ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = '...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(serializeForm(form))
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) { btn.textContent = '✓'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200); }
      })
      .catch(function () { if (btn) { btn.textContent = original; btn.disabled = false; } });
  });

  function serializeForm(form) {
    var obj = { quantity: 1 };
    var idInput = form.querySelector('[data-variant-id]');
    if (idInput) obj.id = idInput.value;
    // Quantity block may live outside the form — look in the product root.
    var root = form.closest('[data-product-root]') || document;
    var qty = root.querySelector('[data-qty] input');
    if (qty) obj.quantity = parseInt(qty.value, 10) || 1;
    return obj;
  }
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }
})();
